import React from 'react';
// COMPONENTS
// ANTD
import Card from 'antd/lib/card';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
//

// new leads in the last 30 days
// invoices paid in the last 30 days
// Sessions on your calendar in the next 30 days

// const STAT_CARDS = [
//   {
//     _id: '1',
//     backgroundColor: '#9b59b6',
//     tooltipText: 'Leads from the last 30 days',
//     iconType: 'idcard',
//     title: 'New Leads',
//     value: '104',
//     linkTo: '/app/clients',
//   },
//   {
//     _id: '2',
//     backgroundColor: '#2ecc71',
//     tooltipText: 'invoices paid in the last 30 days',
//     iconType: 'shop',
//     title: 'Recent Earnings',
//     value: '$11,992.92',
//     linkTo: '/app/clients',
//   },
//   {
//     _id: '3',
//     backgroundColor: '#3498db',
//     tooltipText: 'Sessions on your calendar in the next 30 days',
//     iconType: 'calendar',
//     title: 'Upcoming Sessions',
//     value: '4',
//     linkTo: '/app/calendar',
//   },
// ];

const StatCard = ({
  history, title, tooltipText, linkTo, value, iconType, backgroundColor,
}) => (
  <Card
    onClick={() => history.push(linkTo)}
    style={{
      cursor: 'pointer',
      height: 120,
      backgroundColor,
      borderRadius: 4,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    bodyStyle={{
      height: '100%',
      width: '100%',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Row style={{ width: '100%', padding: 8 }} type="flex" align="center" justify="center">
      <Col xs={9}>
        <Icon type={iconType} style={{ fontSize: 60, color: '#fff' }} />
      </Col>
      <Col xs={15} style={{ textAlign: 'left' }}>
        <p style={{ color: '#fff' }}>{title}</p>
        <h1 style={{ color: '#fff', fontSize: 32, margin: 0 }}>{value}</h1>
      </Col>
    </Row>
    <Tooltip title={tooltipText}>
      <Icon
        type="question-circle-o"
        style={{
          color: '#fff',
          position: 'absolute',
          top: 6,
          right: 7,
        }}
      />
    </Tooltip>
  </Card>
);

export default StatCard;



// WEBPACK FOOTER //
// ./src/routes/app-home/StudioDashboard/StatCard/index.js